
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restplasser/ut",
      function () {
        return require("private-next-pages/restplasser/ut.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restplasser/ut"])
      });
    }
  